export default "<ion-label>\n  {{ phoneNumber}}  \n</ion-label>\n";